import { useEffect } from 'react';
import { analyticsTrackEvent } from '../../../../../../../../../core/analytics';
import {
  ACTION_SEE_SWIMLANE,
  DRAWER_TYPE_FLU_SHOT,
  PROFILE_DISCOVER,
} from '../../../../../../../../../core/analytics/events';
import { CategoryIds } from '../../../../../../../../Account/Profile/util/tileEnums';

export default (hasFluShots: boolean) => {
  useEffect(() => {
    analyticsTrackEvent(PROFILE_DISCOVER, {
      action: ACTION_SEE_SWIMLANE,
      categoryId: hasFluShots ? CategoryIds.FAVORITES : CategoryIds.GET_STARTED,
      drawerType: DRAWER_TYPE_FLU_SHOT,
    });
  }, [hasFluShots]);
};
